import { useEffect, useState } from "react";
import { Reveal, Stagger, staggerItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { Check, ChatCircleText } from "@phosphor-icons/react";
import { api, API } from "../lib/api";

export default function Especialidades() {
  const [separators, setSeparators] = useState([]);
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    api.get("/separators").then(({ data }) => setSeparators(data.separators || [])).catch(() => {});
    api.get("/pricing").then(({ data }) => setPricing(data)).catch(() => {});
  }, []);

  const base = pricing?.base_separators || [];
  const sheets = pricing?.included_sheets || [];

  return (
    <section
      id="especialidades"
      data-testid="especialidades-section"
      className="py-24 md:py-36 bg-[#F6F1E7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-6">
            <span className="text-[#8A9A6F]">04</span> &nbsp;/&nbsp; Qué incluye
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Todo pensado, hasta el último detalle.
          </h2>
          <p className="text-[#4A554E] mt-6 max-w-xl leading-relaxed font-light">
            Cada carpeta llega lista para usar, con separadores ilustrados a mano y hojas para llevar
            el control de tu día a día.
          </p>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-14 items-start">
          {/* Separator teasers */}
          <Reveal>
            <p className="overline mb-4">Algunos de nuestros separadores</p>
            <div className="grid grid-cols-3 gap-3">
              {separators.map((key, i) => (
                <div
                  key={key}
                  data-testid={`separator-${i}`}
                  className="group relative rounded-xl overflow-hidden aspect-[3/4] bg-white border border-[#E3E0D6] shadow-sm"
                >
                  <img
                    src={`${API}/images/${key}`}
                    alt={`Separador ${i + 1}`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                  />
                </div>
              ))}
            </div>
            <p className="text-xs text-[#9CA3AF] mt-3 italic">
              Y muchas más especialidades disponibles al configurar tu carpeta.
            </p>
          </Reveal>

          {/* Included */}
          <Stagger className="space-y-8">
            <motion.div variants={staggerItem}>
              <p className="overline mb-4">Incluido en todas las carpetas</p>
              <div className="flex flex-wrap gap-2">
                {base.map((b) => (
                  <span
                    key={b}
                    className="text-sm rounded-full bg-white text-[#2D3732] border border-[#E3E0D6] px-4 py-2"
                  >
                    {b}
                  </span>
                ))}
              </div>
            </motion.div>

            <motion.div variants={staggerItem}>
              <p className="overline mb-4">Hojas especiales según tus especialidades</p>
              <ul className="space-y-3">
                {sheets.map((s) => (
                  <li key={s} className="flex items-start gap-3 text-[#4A554E]">
                    <span className="w-5 h-5 rounded-full bg-[#A3B18A] flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check size={12} weight="bold" className="text-white" />
                    </span>
                    <span className="font-light">{s}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div variants={staggerItem}>
              <div
                data-testid="specialty-contact-note"
                className="rounded-2xl border border-[#E3E0D6] bg-white px-6 py-5 flex flex-col sm:flex-row sm:items-center gap-4"
              >
                <span className="w-11 h-11 rounded-full bg-[#EEF1E8] flex items-center justify-center flex-shrink-0">
                  <ChatCircleText size={22} weight="light" className="text-[#8A9A6F]" />
                </span>
                <div className="flex-1">
                  <p className="text-[#2D3732]">¿No encuentras tu especialidad?</p>
                  <p className="text-sm text-[#6B705C] font-light mt-0.5">
                    Escríbenos y estudiamos añadirla a tu carpeta.
                  </p>
                </div>
                <a
                  href="#contacto"
                  data-testid="specialty-contact-link"
                  className="inline-flex items-center justify-center gap-2 border border-[#A3B18A] text-[#2D3732] hover:bg-[#EEF1E8] rounded-full px-5 py-2.5 text-sm transition-colors duration-300"
                >
                  Escríbenos
                </a>
              </div>
            </motion.div>
          </Stagger>
        </div>
      </div>
    </section>
  );
}
